export default "__VITE_ASSET__ec18175b__"